<div class="container">
  <div class="text-center">
    <h2 class="mainHeading slide-in-left">
      <strong>Dumpster Location</strong>
    </h2>
  </div>

  <div class="row mb-2">
    <div class="col-md-3">
      <label for="userType">Dumpster</label>
      <select
        id="userType"
        class="form-select"
        (change)="onDumpsterChange($event)"
      >
        <option selected disabled>Select Dumpster</option>
        <option *ngFor="let type of dumpsterList" [value]="type.userId">
          {{ type.companyName }}
        </option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <google-map
        class="mt-2"
        height="95vh"
        width="100%"
        [center]="center"
        [zoom]="zoom"
      >
        <map-marker
          *ngFor="let marker of markers"
          [position]="marker.position"
          [icon]="marker.icon"
          [title]="marker.title"
          (mapClick)="onMarkerClick(marker)"
        ></map-marker>
      </google-map>
    </div>
  </div>
</div>
